module.exports = __webpack_public_path__ + "img/thumb_32.fc51bf00.jpg";